import {SCOPE_FULL_SET, SCOPE_SMALL_SET} from "../config/actions";

let defaultState = {
    small: null,
    smallLastLoaded: null,
    full: null,
    fullLastLoaded: null
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case SCOPE_SMALL_SET:
            return {
                ...state,
                small: action.data,
                smallLastLoaded: new Date()
            };
        case SCOPE_FULL_SET:
            return {
                ...state,
                full: action.data,
                fullLastLoaded: new Date()
            };
        default:
            return state;
    }
};
